<div class="button-container">
    <button type="button" class="btn button-action {{ className }}" (click)="butttonAction(); $event.stopPropagation()">
        <ng-content select="[iconButton]"></ng-content>
        <ng-content select="[textButton]"></ng-content>
    </button>
</div>
